import { AvisConstants } from "../data/avisConstants";
import { PortalReportStatusTypeInfo } from "../generated/data-contracts";
import { BlankMediaUseType, IUrlParamsBlankMedia } from "../models";
import { AvisUtils } from "./";

export class BlankMediaUrls {
  static readonly applicationsList = `/${AvisConstants.url_part_portal_blank_media}/applications`;
  static readonly applicationViewNewI = `${BlankMediaUrls.applicationsList}/Importer`;
  static readonly applicationViewNewP = `${BlankMediaUrls.applicationsList}/ProfessionalUser`;
  static readonly applicationView = `${BlankMediaUrls.applicationsList}/${AvisConstants.url_application_type_param}`;
  static readonly applicationViewWithId = `${BlankMediaUrls.applicationView}/${AvisConstants.url_application_id_param}`;
}
export class BlankMediaUtils {
  static getUrlWithParams(
    path: string | undefined,
    urlParams?: IUrlParamsBlankMedia,
    addFilterTag?: boolean,
  ): string {
    let result = path ?? AvisUtils.getStartPagePath();

    if (addFilterTag && result.indexOf(AvisConstants.url_hash_filter) == -1)
      result += AvisConstants.url_hash_filter;

    //return if params not provided
    if (!urlParams) return result;

    if (urlParams.applicationType) {
      result = result.replace(
        AvisConstants.url_application_type_param,
        urlParams.applicationType,
      );
    }

    if (urlParams.applicationId) {
      result = result.replace(
        AvisConstants.url_application_id_param,
        btoa(urlParams.applicationId.toString()),
      );
    }
    return result;
  }

  static getUrlParams(): IUrlParamsBlankMedia {
    const urlParams: IUrlParamsBlankMedia = {};
    const pathname = location.pathname.slice(1);
    const pathParts = pathname.split("/");
    if (pathParts.length < 3) return urlParams;

    if (pathParts[1] == "applications") {
      urlParams.applicationType = pathParts[2] as BlankMediaUseType;

      if (pathParts.length >= 4) {
        urlParams.applicationId = parseInt(
          AvisUtils.atobParam("applicationId", pathParts[3]),
        );
      }
    }

    return urlParams;
  }

  static readonly hasNoPortalReport = (
    reportStatus: PortalReportStatusTypeInfo | undefined,
    eventNotOccured: boolean | undefined,
    isRowsRows: boolean | undefined,
  ) => {
    if (eventNotOccured) return false;

    if (!reportStatus) return false;

    const isReadOnlyStatus =
      reportStatus.value != "NotSubmitted" && reportStatus.value != "Rejected";

    return isReadOnlyStatus && isRowsRows;
  };
}
